// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb7495db","455":"fd9d10c4","977":"d14f24ba"}[chunkId] + ".chunk.js";
};